import React from 'react';
import { Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const INPIBanner = () => {
  const { language } = useLanguage();

  const bannerText = {
    fr: "Modèles déposés et protégés par Certificats INPI",
    en: "Models registered and protected by INPI Certificates",
    pt: "Modelos registados e protegidos por Certificados INPI",
    it: "Modelli depositati e protetti da Certificati INPI",
    ru: "Модели зарегистрированы и защищены сертификатами INPI",
    zh: "模型已注册并受INPI证书保护"
  };

  const roleText = {
    fr: "LENODA – Intégrateur & Maître d'Ouvrage Délégué | Garanties Décennales & RC Pro Internationales",
    en: "LENODA – Integrator & Delegated Project Owner | Ten-Year Guarantees & International Professional Liability",
    pt: "LENODA – Integrador & Dono de Obra Delegado | Garantias Decenais & RC Pro Internacionais",
    it: "LENODA – Integratore & Committente Delegato | Garanzie Decennali & RC Pro Internazionali",
    ru: "LENODA – Интегратор и Делегированный заказчик | Десятилетние гарантии и международная профессиональная ответственность",
    zh: "LENODA – 集成商和委托业主 | 十年保证和国际专业责任"
  };

  return (
    <div className="fixed top-20 left-0 right-0 z-40 bg-gradient-to-r from-emerald-600 via-emerald-700 to-sky-600">
      <div className="max-w-7xl mx-auto px-4 py-2">
        <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-white text-center">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-emerald-200" />
            <span className="text-xs md:text-sm font-semibold">
              {bannerText[language] || bannerText.fr}
            </span>
          </div>
          <span className="hidden md:block text-emerald-300">|</span>
          <span className="text-xs text-emerald-100">
            {roleText[language] || roleText.fr}
          </span>
        </div>
      </div>
    </div>
  );
};
